import { Loading } from "@mnk/frontend/components/Loading";
import { SideMenu } from "@mnk/frontend/components/pages/settings/sideMenu";
import { NewForm } from "@mnk/frontend/components/pages/settings/users/NewForm";
import { trpc } from "@mnk/frontend/lib/trpc";
import { NotFound } from "@mnk/frontend/pages/NotFound";

export const UsersNewSetting = () => {
  const getUser = trpc.getUser.useQuery();
  const user = getUser.data;

  if (getUser.isLoading) return <Loading />;
  if (user?.role !== "admin") return <NotFound />;

  return (
    <div className="flex max-w-[1080px] mx-auto pt-8 px-4">
      <SideMenu />
      <NewForm />
    </div>
  );
};
